(() => {
  const updateCart = (cart) => {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-lc-cart-count]').forEach((badge) => {
      badge.textContent = String(cart.item_count);
    });
    document.querySelectorAll('[data-lc-cart-link]').forEach((link) => {
      const label = link.dataset.lcCartLabel || 'Your cart';
      link.setAttribute('aria-label', `${label}, ${cart.item_count} items`);
    });
  };
  document.addEventListener('lc:cart-updated', (event) => updateCart(event.detail && event.detail.cart));
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then(updateCart)
      .catch(() => {});
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-lc-menu][open], [data-lc-nav-dropdown][open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenus = [...document.querySelectorAll('[data-lc-menu][open], [data-lc-nav-dropdown][open]')];
    const menu = event.target.closest('[data-lc-menu][open], [data-lc-nav-dropdown][open]') || openMenus.at(-1);
    if (!menu) return;
    event.preventDefault();
    menu.open = false;
    menu.querySelector('summary').focus();
  });
})();
